// src/components/ui/index.js

export function LoadingSpinner({ size = 40 }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '3rem' }}>
      <div style={{
        width: size, height: size,
        border: `3px solid rgba(249,168,201,0.2)`,
        borderTopColor: 'var(--accent-pink)',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }} />
    </div>
  );
}

export function ErrorBox({ message, onRetry }) {
  return (
    <div className="error-box">
      <div className="emoji">😔</div>
      <p style={{ color: 'var(--text-muted)', marginBottom: '1rem' }}>
        {message || 'خطا در بارگذاری اطلاعات'}
      </p>
      {onRetry && (
        <button className="btn-secondary" onClick={onRetry} style={{ fontSize: '0.85rem' }}>
          تلاش مجدد
        </button>
      )}
    </div>
  );
}

export function EmptyState({ icon = '🕯️', fa, en, lang = 'fa' }) {
  return (
    <div className="error-box">
      <div className="emoji">{icon}</div>
      <p style={{ color: 'var(--text-muted)' }}>{lang === 'fa' ? fa : en}</p>
    </div>
  );
}

export function SkeletonCard({ height = 280 }) {
  return (
    <div className="skeleton" style={{ height, borderRadius: 'var(--radius-lg)' }} />
  );
}

export function SkeletonGrid({ count = 6, height = 280 }) {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(280px,1fr))',
      gap: '1.25rem'
    }}>
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} height={height} />
      ))}
    </div>
  );
}

export function SectionHeader({ badge, title, sub }) {
  return (
    <div className="section-header">
      <div className="tag-badge">{badge}</div>
      <h2 className="grad-text" style={{ fontSize: 'clamp(1.8rem,4vw,2.6rem)', fontWeight: 800 }}>
        {title}
      </h2>
      {sub && <p style={{ color: 'var(--text-muted)', marginTop: '0.5rem', fontSize: '0.95rem' }}>{sub}</p>}
    </div>
  );
}

export function CategoryFilter({ categories, active, onSelect, lang }) {
  const allLabel = lang === 'fa' ? 'همه' : 'All';
  return (
    <div style={{ display: 'flex', gap: '0.6rem', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '2rem' }}>
      <button
        onClick={() => onSelect(null)}
        style={{
          background: !active ? 'linear-gradient(135deg,var(--accent-pink),var(--accent-purple))' : 'rgba(249,168,201,0.08)',
          border: '1px solid var(--border-medium)',
          borderRadius: 'var(--radius-full)',
          color: !active ? '#1a0a2e' : 'var(--text-secondary)',
          fontWeight: !active ? 700 : 400,
          padding: '6px 18px',
          cursor: 'pointer',
          fontSize: '0.82rem',
          transition: 'all var(--transition)',
          fontFamily: 'inherit',
        }}
      >
        {allLabel}
      </button>
      {categories.map((cat) => (
        <button
          key={cat.slug}
          onClick={() => onSelect(cat.slug)}
          style={{
            background: active === cat.slug
              ? `linear-gradient(135deg,${cat.color},${cat.color}88)`
              : 'rgba(249,168,201,0.06)',
            border: `1px solid ${active === cat.slug ? cat.color : 'var(--border-subtle)'}`,
            borderRadius: 'var(--radius-full)',
            color: active === cat.slug ? '#1a0a2e' : 'var(--text-secondary)',
            fontWeight: active === cat.slug ? 700 : 400,
            padding: '6px 18px',
            cursor: 'pointer',
            fontSize: '0.82rem',
            transition: 'all var(--transition)',
            fontFamily: 'inherit',
          }}
        >
          {lang === 'fa' ? cat.name_fa : cat.name_en}
        </button>
      ))}
    </div>
  );
}

export function StarRating({ rating = 5, size = '1rem' }) {
  return (
    <div style={{ color: 'var(--accent-pink)', fontSize: size, letterSpacing: '2px' }}>
      {'★'.repeat(Math.max(0, Math.min(5, rating)))}
      {'☆'.repeat(5 - Math.max(0, Math.min(5, rating)))}
    </div>
  );
}

export function Avatar({ name = '', color = 'linear-gradient(135deg,#f9a8c9,#c8a2c8)', size = 40 }) {
  return (
    <div style={{
      width: size, height: size,
      borderRadius: '50%',
      background: color,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 700,
      fontSize: size * 0.38,
      color: '#1a0a2e',
      flexShrink: 0,
    }}>
      {name[0] || '?'}
    </div>
  );
}

export function Divider() {
  return (
    <div style={{
      height: '1px',
      background: 'linear-gradient(90deg, transparent, var(--border-medium), transparent)',
      margin: '0 1.5rem',
    }} />
  );
}
